import React, { useRef } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import ServiceCapacityCalculator from './components/ServiceCapacityCalculator';
import CateringPackages from './components/CateringPackages';
import CorporateTestimonials from './components/CorporateTestimonials';
import EventGallery from './components/EventGallery';
import InquiryForm from './components/InquiryForm';
import EventTimeline from './components/EventTimeline';
import DietaryAccommodations from './components/DietaryAccommodations';

const CateringExcellence = () => {
  const inquiryFormRef = useRef(null);

  const scrollToInquiry = () => {
    inquiryFormRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-20">
        <HeroSection onInquiryClick={scrollToInquiry} />
        <ServiceCapacityCalculator />
        <CateringPackages onCustomizeClick={scrollToInquiry} />
        <EventGallery />
        <CorporateTestimonials />
        <EventTimeline />
        <DietaryAccommodations />
        <div ref={inquiryFormRef}>
          <InquiryForm />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CateringExcellence;